import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { ICellRendererParams } from 'ag-grid-community';
import { CellCustomRenderer } from '../../../shared/ag-grid-table/cell-custom-renderer';
import { CellDropdownSelect, CellDropdownSelectProps } from './cell-dropdown-select';

export class CellDropdownSelectRenderer extends CellCustomRenderer {
    root!: Root;

    init(params: ICellRendererParams) {
        this.eGui = document.createElement('div');
        this.root = createRoot(this.eGui);
        this.setCell(params);
    }

    setCell(params: ICellRendererParams) {
        const props: CellDropdownSelectProps = {
            testId: params?.data?.select.testId,
            options: params?.data?.select?.options ?? [],
            onChange: params?.data?.select.onChange,
        };
        const Component = React.createElement(CellDropdownSelect, props);
        this.root.render(Component);
    }
}
